// About route: the app version and build, the signed-in user's access and the loaded grid codes; the screen is AboutPage.
import { createFileRoute } from "@tanstack/react-router";

import { AboutPage } from "@/app/shell/AboutPage";

export const Route = createFileRoute("/_app/about")({
  staticData: { crumb: "About" },
  component: AboutPage,
});
